<template>
    <div>
        <div class="footer" id="footer">
            <p>© Trustlook .Inc</p>
        </div>
    </div>

</template>

<script>
    import { downAPPBottom } from "../views/public/validator";
    export default{
        name: 'customFooter',
        mounted(){
            downAPPBottom('footer','80px');
        }
    }
</script>

<style lang="scss" scoped>
  .footer{
      width: 100%;
      height: 80px;
      font-size: 12px;
      border-top: 1px solid rgba(210,220,245,1);
      box-sizing: border-box;
      padding: 20px 43px 0;
      font-weight: 600;
      @include flex-end-center;
      @include absolute-left-bottom(0,0);
      z-index: 999;
      text-align: right;
      color: rgba(28, 28, 28, 1);
      font-family: NexaBold;
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue